export class UiTicketQuickViewDto {
    alias: string;
    name: string;
    type: string;
    uiIcon: string;
    uiObjectsLength: number;
    uiExtraObjectsLength: number;
    // TM-1000002018: replaces uiLatestObjectId — readable „Name (VSNR: x)" line for the pin popover
    uiObjectLabel: string;
    uiBgColor: string;
}